import { put, select, call } from "redux-saga/effects";
// Components
import { COMMAND_BOX_FLAG } from "../../Components/CommandBox";
// Classes
import { HERO_LEVELS } from "../../Classes/utils/constants";
// Store
import { gameDataActions } from '../Actions/gameDataActions';
import { logsActions } from '../Actions/logsActions';
import { heroActions } from '../Actions/heroActions';
import { getHeroXP, getHeroLevel, getHeroName, getFightDataEndFightData } from '../Selectors/selectors';
import fightSaga, { FIGHT_SAGA_RESULTS } from "./fightSaga";
import eventSaga from './eventSaga';
// Helpers
import { MODAL_FLAG, GAME_STATE } from "../../Helpers/constants";
import { log } from "../../Helpers/logger";

export function* startFight(){
    while(true){
        const fightSagaResult = yield call(fightSaga);
        let state = yield select();
    
        log.saga.log("fightSagaResult::", fightSagaResult);

        const heroName = yield select(getHeroName); 
        log.saga.log(heroName);
        // log.saga.log("fightSagaResult::", fightSagaResult, FIGHT_SAGA_RESULTS.PLAYER_VICTORY);
    
        switch (fightSagaResult) {
            case FIGHT_SAGA_RESULTS.PLAYER_DEAD: {
                yield put(gameDataActions.setGameState(GAME_STATE.GAME_OVER));
                yield put(gameDataActions.setCommandBoxFlag(COMMAND_BOX_FLAG.GAME_OVER));
                yield put(logsActions.add("C'est ainsi que s'arrêtent les aventures de " + heroName));
                break;
            }
            case FIGHT_SAGA_RESULTS.PLAYER_ESCAPE: {
                yield put(gameDataActions.setToNormalMode());
                yield put(logsActions.add(heroName + " à réussi à s'enfuir !"));
                break;
            }
            case FIGHT_SAGA_RESULTS.PLAYER_VICTORY: {
                log.saga.log("test");
                const { expDrop, goldDrop } = yield select(getFightDataEndFightData);
                
                state = yield select();

                log.saga.log(state);
                
                yield put(gameDataActions.setToVictoryMode());
                yield put(heroActions.gainXp(expDrop));
                yield put(heroActions.updateGold(goldDrop));
    
                const heroXp = yield select(getHeroXP);
                const heroLevel = yield select(getHeroLevel);
                log.saga.log(heroXp, heroLevel);
                if (heroLevel < HERO_LEVELS.length && heroXp >= HERO_LEVELS[heroLevel].xp) {
                    const statsReducerPayload = [
                        ['maxHealth', HERO_LEVELS[heroLevel].maxHealth],
                        ['maxMana', HERO_LEVELS[heroLevel].maxMana]
                    ];
                    const nextLevel = heroLevel + 1;
                    
                    yield put(heroActions.levelUp(nextLevel, statsReducerPayload));
                    
                    yield put(logsActions.add(<b> {heroName + " est passé au niveau " + nextLevel} </b>));
                }
    
                yield put(logsActions.add(heroName + " est sortie vainqueur de ce rude combat !"));
                break;
            }
                
            default:
                break;
        } 
        
        return fightSagaResult;
    } 
}

export function* startEvent(event) {
    // log.saga.log('startEvent', event)
    while(true) {
        const heroName = yield select(getHeroName);
        
        // Determiner quel event mettre en place
        const { defaultSpeaker } = event;
        if (defaultSpeaker) {
            yield put(logsActions.add(heroName + " se fait aborder par " + defaultSpeaker.name));
        } else {
            yield put(logsActions.add("Mais qu'arrive-t'il à " + heroName + ' ?'));
        }
        
        const eventResult = yield call(eventSaga, event);
        return eventResult;
    }
}
